import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import "datatables.net-dt";
import $ from "jquery";
import { baseURL } from "../../axios/common";
import { Link } from "react-router-dom";

const ListActivities = () => {
  const [activities, setActivities] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });

  useEffect(() => {
    fetchActivities(pagination.page, pagination.limit);
  }, [pagination]);

  useEffect(() => {
    if (activities.length) {
      if (!$.fn.DataTable.isDataTable("#ActivitiesTable")) {
        $("#ActivitiesTable").DataTable();
      }
    }
  }, [activities]);

  // Fetch Activity List
  const fetchActivities = async (page, limit) => {
    try {
      const response = await axios.post(
        baseURL + "admin/getActivityList",
        {
          page,
          limit,
          language: "en",
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setActivities(response.data.data);
    } catch (error) {
      console.error("Error fetching activities:", error);
    }
  };

  return (
    <div>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid"></div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h2 className="card-title">Activities</h2>
                    </div>
                    <div className="card-body">
                      <table id="ActivitiesTable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Start Date</th>
                            <th>Start Time</th>
                            <th>Duration (mins)</th>
                            <th>Location</th>
                            <th>Participants</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activities.map((activity, index) => (
                            <tr key={activity.id}>
                              <td>{index + 1}</td>
                              <td>{activity.name}</td>
                              <td>{activity.start_date}</td>
                              <td>{activity.start_time}</td>
                              <td>{activity.duration}</td>
                              <td>{activity.location_text}</td>
                              <td>{activity.number_of_person}</td>
                              <td className="table_action text-center">
                                <div className="active_td">
                                  <Link to={`/activity/show-activity/${activity.id}/${activity.user_id}`}>
                                    <i className="fa fa-eye" />
                                  </Link>
                                  <Link to="#" className="">
                                    <i className="fa fa-trash" style={{ color: "#f00" }} />
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default ListActivities;
